module.exports = __webpack_public_path__ + "static/media/AvenirLTPro-Medium.c1fd84aa.eot";